import {QUESTION, EDITABLE_BY, 
        OPPONENT_NAME_MN, 
        APPLICATION_OPPONENT, 
        APPLICATION_MEDICAL_EXPERT_FEES, 
        ESTIMATED_MEDICAL_EXPERT_FEES_MN
    } from "./constants";

// Build rows (data) for the Editing Settings table.
export const buildEditingSettingsTableData = ({
    questions,
    editingSettings,
    editingSettingsValues,
    getFieldFormEditingSetting,
    getEditingSettingFromTableName,
    getEditingSettingFromColumnName
}) => {
    const editingSettingsForFields = editingSettings.filter(e => e.columnName);
    
    const allQuestions = [
        ...editingSettingsForFields.map(editingSetting => getFieldFormEditingSetting(editingSetting)),
        ...questions,
    ];

    const editingSettingsTableData = allQuestions.map((question) => {

        let editingSetting = null;
        if (question.id) {
            editingSetting = editingSettings.find(es => es.questionId === question.id);
        }

        if (!editingSetting && question.machineName === OPPONENT_NAME_MN) {
            editingSetting = getEditingSettingFromTableName(APPLICATION_OPPONENT);
        } else if (!editingSetting && question.machineName === ESTIMATED_MEDICAL_EXPERT_FEES_MN) {
            editingSetting = getEditingSettingFromTableName(APPLICATION_MEDICAL_EXPERT_FEES);
        }
        else if (!editingSetting && !question.id) {
            editingSetting = getEditingSettingFromColumnName(question.columnName)
        }

        return {
            [QUESTION]: {
                    id: question.id,
                    name: question.name,
                    isParent: question.isParent,
                    isRequired: question.isRequired,
                },
            [EDITABLE_BY]: editingSetting
                ? {
                    id: editingSetting.id,
                    value: editingSettingsValues[editingSetting.id]
                }
                : null
        };
    });
    
    return editingSettingsTableData;
}
